export default __webpack_public_path__ + "static/map-body-tablet-8aafd88bc7680d2b84ad322ef60acc6b.png";